<template>
  <div class="rapport-avhandling-container mb-3">
    <v-textarea
      auto-grow
      rows="1"
      outlined
      label="Avhandlingens originaltitel"
      v-model="englishTitle"
      hide-details="auto"
    ></v-textarea>
    <v-expansion-panels>
      <slot name="image"></slot>
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Information </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-text-field
            outlined
            label="Universitet"
            v-model="university"
            messages="syns i presentation"
            class="mb-2"
          ></v-text-field>
          <v-text-field outlined label="Institution" v-model="institution"></v-text-field>
          <div class="flex">
            <v-text-field outlined label="Författare" v-model="author"></v-text-field>
            <v-text-field outlined label="Publiceringsår" v-model="year"></v-text-field>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Länkar </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-text-field
            outlined
            label="Länk till universitetets egen databas"
            placeholder="https://... "
            v-model="originalSourceLink"
            class="mb-2"
          ></v-text-field>
          <v-text-field
            outlined
            label="Länk Libris"
            messages="Kolla på http://www.libris.kb.se/"
            v-model="librisLink"
            class="mb-2"
          ></v-text-field>
          <div class="flex">
            <v-text-field
              outlined
              label="Länk populärvetenskap"
              messages="Länk till ev. annan populärvetenskaplig artiklel; t.ex. i Havsutsikt "
              v-model="popLink"
              class="mb-2"
            ></v-text-field>
            <v-text-field
              outlined
              label="Länk pressmeddelande"
              messages="T.ex på Forskning.se, http://www.forskning.se..."
              v-model="pressReleaseLink"
              class="mb-2"
            ></v-text-field>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Nyckelord </v-expansion-panel-header>
        <v-expansion-panel-content> <slot name="keywords"></slot> </v-expansion-panel-content
      ></v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: 'RapportAvhandling',
  props: {
    article_title_original: { type: String },
    article_name: { type: String },
    article_department: { type: String },
    article_author: { type: String },
    article_year: { type: String },
    article_originalsource: { type: String },
    article_reference_libris: { type: String },
    article_reference_pop: { type: String },
    article_reference: { type: String },
  },
  computed: {
    englishTitle: {
      get() {
        return this.article_title_original
      },
      set(val) {
        this.$emit('update', { article_title_original: val })
      },
    },
    university: {
      get() {
        return this.article_name
      },
      set(val) {
        this.$emit('update', { article_name: val })
      },
    },
    institution: {
      get() {
        return this.article_department
      },
      set(val) {
        this.$emit('update', { article_department: val })
      },
    },
    author: {
      get() {
        return this.article_author
      },
      set(val) {
        this.$emit('update', { article_author: val })
      },
    },
    year: {
      get() {
        return this.article_year
      },
      set(val) {
        this.$emit('update', { article_year: val })
      },
    },
    originalSourceLink: {
      get() {
        return this.article_originalsource
      },
      set(val) {
        this.$emit('update', { article_originalsource: val })
      },
    },
    librisLink: {
      get() {
        return this.article_reference_libris
      },
      set(val) {
        this.$emit('update', { article_reference_libris: val })
      },
    },
    popLink: {
      get() {
        return this.article_reference_pop
      },
      set(val) {
        this.$emit('update', { article_reference_pop: val })
      },
    },
    pressReleaseLink: {
      get() {
        return this.article_reference
      },
      set(val) {
        this.$emit('update', { article_reference: val })
      },
    },
  },
}
</script>

<style lang="less" scoped>
.rapport-avhandling-container {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  .flex {
    display: flex;
    gap: 15px;
  }
}
</style>
